<template>
	<div class="modal-play" v-if="$store.state.authentication.url">
		<header class="header-section" style="position: relative !important;">
			<div class="container-fluid p-0">
				<div class="header-wrapper header-play">
					<div class="menu__left__wrap">
						<div class="logo-menu px-2">
								<!-- <router-link to="/" class="logo"> -->
									<img src="@/assets/img/logo.png" alt="logo" style="width: 100px">
								<!-- </router-link > -->
						</div>
					</div>
					<div class="mneu-btn-grp" v-if="$store.state.authentication.loggedIn">
						<a class="play-action-button" @click="fullscreen()"><md-icon>fullscreen</md-icon></a>
						<a class="play-action-button" style="font-size: 25px;" @click="closeGame()"><span>×</span></a>
					</div>
				</div>
			</div>
	   </header>

		<iframe ref="game_iframe" :src="$store.state.authentication.url" frameborder="0" allow="fullscreen" allowfullscreen v-if="$store.state.authentication.url.length > 0" style="width: 100%;height: 100%"></iframe>
		<!-- <div style="position: fixed; top:5px; left: 5px;width: 100px; display: flex; justify-content: center; align-items: center;z-index: 999999999;opacity: 0.3;">
			<img src="@/assets/img/logo-menu.png">
		</div> -->
		<!-- <div class="action-button" style="top:5px;font-size: 24px;" @click="closeGame()">×</div>
		<div class="action-button" style="top:50px;" @click="fullscreen()">
			<md-icon>fullscreen</md-icon>
		</div> -->

		<div class="confirm-box" v-if="confirmClose">
			<div class="confirm-box-message">
				<div class="confirm-message">
					<span class="confirm-text-message">{{$store.state.lang.text.logout_confirm[$store.state.lang.language]}}</span>
				</div>
				<div class="confirm-bottom">
					<div class="create__btn" style="cursor: pointer;padding: 0 10px">
						<a class="cmn--btn" @click="confirmClose = false" style="background-color: red;"><span>{{$store.state.lang.text.cancel[$store.state.lang.language]}}</span></a>
					</div>
					<div class="create__btn" style="cursor: pointer;padding: 0 10px">
						<a class="cmn--btn" @click="closeGame()"><span>{{$store.state.lang.text.confirm[$store.state.lang.language]}}</span></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import HeaderPlay from "./HeaderPlay"
	export default {
		components: {
			HeaderPlay
		},
		data() {
			return {
				confirmClose: false
			}
		},
		methods: {
			closeGame() {
				if(!this.confirmClose) {
					this.confirmClose = true;
				} else {
					this.$store.state.authentication.url = "";
					this.confirmClose = false;
				}
			},
			fullscreen() {
				if (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled) {

					var iframe = this.$refs.game_iframe;

					if (iframe.requestFullscreen) {
						iframe.requestFullscreen();
					} else if (iframe.webkitRequestFullscreen) {
						iframe.webkitRequestFullscreen();
					} else if (iframe.mozRequestFullScreen) {
						iframe.mozRequestFullScreen();
					} else if (iframe.msRequestFullscreen) {
						iframe.msRequestFullscreen();
					}
				}
			}
		}
	}
</script>
<style>
	.header-play {
		padding: 5px 40px;
	}
	@media screen and (max-width: 991px) {
		.header-play {
			padding: 5px 10px !important;
		}
	}
	.modal-play {
		width: 100%;
		height: 100%;
		position: fixed;
		display: flex;
		flex-direction: column;
		top: 0;
		left: 0;
		z-index: 999999;
		background-color: #000;
	}
	.play-action-button {
		width: 32px;
		height: 32px;
		cursor: pointer;
		border-radius: 32px;
		background-color: rgba(255,255,255,0.5);
		opacity: 0.4;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 999999999;
		color:#000;
	}
	.confirm-box {
		z-index: 999999;
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		padding: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		background-color: rgba(0,0,0,0.7);
	}
	.confirm-message {
		width: 100%;
		text-align: center;
		padding: 18px 0;
	}
	.confirm-bottom {
		display: flex;
		justify-content: center;
	}
	.confirm-box-message {
		background-color: #FFF;
		border-radius: 15px;
		width: 100%;
		padding: 0px 20px;
		max-width: 360px;
	}
	.confirm-text-message {
		text-align: center;
		color: #333;
	}
</style>



// WEBPACK FOOTER //
// src/components/PlayModal.vue